exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-custom-bottom {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: 30px;\n  left: 0;\n  right: 0;\n}\n.custom-control {\n  margin-top: 10px !important;\n}\n#thirdform .custom-calendar-checkbox .custom-checkbox {\n  width: 100%;\n}\n", ""]);

// exports
